import { Injectable } from "@angular/core";
import { RidangoReduxAction } from "@ridango/core";

@Injectable({
    providedIn: "root",
})
export class ProductsSelectorActions {
    static CLEAR_PRODUCT_COUNTS = "[ProductsSelector]: Clear product counts";
    static ADD_PRODUCT = "[ProductsSelector]: Add product";
    static REMOVE_PRODUCT = "[ProductsSelector]: Remove product";


    addProduct(productId: number): RidangoReduxAction {
        return {
            type: ProductsSelectorActions.ADD_PRODUCT,
            payload: productId,
        };
    }

    removeProduct(productId: number): RidangoReduxAction {
        return {
            type: ProductsSelectorActions.REMOVE_PRODUCT,
            payload: productId,
        };
    }

    clearSelectedProducts(): RidangoReduxAction {
        return {
            type: ProductsSelectorActions.CLEAR_PRODUCT_COUNTS,
        };
    }
}
